import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  addSubscriptionPlansButtonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
}));
